import { MotifToast } from '@ey-xd/motif-react';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const GlobalNotification = () => {
  const { toast } = useSelector((state: any) => state.globalAction);
  const dispatch = useDispatch();

  const hadleToastClose = () => {
    dispatch({
      type: 'GLOBAL_TOAST_CLOSE'
    });
  };

  const renderGlobalToast = useCallback(() => {
    if (toast === undefined) {
      return <></>;
    }
    const { message, ...rest } = toast;
    return (
      <div className="fixed z-[99999999999999999999] top-20 right-10">
        <MotifToast
          {...rest}
          onClose={hadleToastClose}
        >
          {message}
        </MotifToast>
      </div>
    );
  }, [toast]);
  return <>{renderGlobalToast()}</>;
};

export default GlobalNotification;
